/**
 * media operations
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import {REST_CALL_UPLOAD_MEDIA_FILE, REST_SERVER_BASE_URL} from "../config";
import {showMessageAction} from "../redux/message/actions";
import {showError} from "./message"
import {updateObjectValueAction} from "../redux/editing/actions";
import {fetchJSONActivity} from "./communication";


export function uploadMediaFile(file, objectId, fieldId, onFinish) {

    return async (dispatch, getState) => {

        const {authorization} = getState();

        let formData = new FormData();
        formData.append("file", file);

        try {

            const json = await fetchJSONActivity(dispatch, "uploading media file",
                REST_SERVER_BASE_URL + REST_CALL_UPLOAD_MEDIA_FILE.path, {
                    method: REST_CALL_UPLOAD_MEDIA_FILE.method,
                    body: formData,
                    headers: {
                        "Authorization": "Bearer " + authorization.accessToken
                    }
                }
            );

            console.log("uploaded media file with server response", json);

            if (!json.url) throw new Error("URL missing");

            // update field
            if (objectId && fieldId) {
                dispatch(updateObjectValueAction(objectId, ['fields', fieldId], json.url));
            }

            dispatch(showMessageAction("uploaded sucessfully"));
            onFinish && onFinish(null, json.url, json.info);
        }
        catch (error) {
            showError(error)(dispatch);
            onFinish && onFinish(error.message || error.msg, null, null);
        }
    }
};